import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LinkActionHandlerDirective } from './link-action-handler.directive';

@NgModule({
  imports: [CommonModule, LinkActionHandlerDirective],
  exports: [LinkActionHandlerDirective],
})
export class LinkActionHandlerModule {}
